import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const utcToLocal = (utcDateString: string) => {
  if (utcDateString && dayjs(utcDateString).isValid()) {
    return dayjs.utc(utcDateString).local().format('MMMM D [at] h:mm A');
  }
  return '';
};

export { utcToLocal };
